'use strict';

var identityModule = angular.module("app.identityModule", []);


identityModule.config(["$stateProvider", "$locationProvider",
    function ($stateProvider: ng.ui.IStateProvider, $locationProvider: angular.ILocationProvider) {

        console.log('app.identityModule config...');

        $stateProvider
            .state('forgottenPan', {
                url: '/forgottenPan',
                templateUrl: 'assets/templates/identity/forgottenPan.html',
                controller: "forgottenPanCtrl",
                resolve: {
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Forgotten Pan"};
                  }],
                }
            })
            .state('forgottenPassword', {
                url: '/forgottenPassword',
                templateUrl: 'assets/templates/identity/forgottenPassword.html',
                controller: "forgottenPasswordCtrl",
                resolve: {
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Forgotten Password"};
                  }],
                }
            })
            .state('changeMobile', {
                url: '/changeMobile',
                templateUrl: 'assets/templates/identity/changeMobile.html',
                resolve: {
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Change Mobile"};
                  }],
                  impersonatorCheck: ['sessionService', '$q','$state', function(sessionService, $q, $state) {
                    var deferred = $q.defer();
                    if (sessionService.getCurrentUserProfile().impersonator === 'True') {
                      $state.go('dashboard');
                      deferred.reject();
                    } else {
                      deferred.resolve();
                    }
                    return deferred.promise;
                  }]
                }
            })
            .state('registerMobile', {
                url: '/registerMobile',
                templateUrl: 'assets/templates/identity/registerMobile.html',
                resolve: {
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Register Mobile"};
                  }],
                  impersonatorCheck: ['sessionService', '$q','$state', function(sessionService, $q, $state) {
                    var deferred = $q.defer();
                    if (sessionService.getCurrentUserProfile().impersonator === 'True') {
                      $state.go('dashboard');
                      deferred.reject();
                    } else {
                      deferred.resolve();
                    }
                    return deferred.promise;
                  }]
                }
            })
            .state('changePassword', {
                url: '/changePassword',
                templateUrl: 'assets/templates/identity/changePassword.html',
                controller: "changePasswordCtrl",
                resolve: {
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Change Password"};
                  }],
                }
            })
            .state('changeEmail', {
                url: '/changeEmail',
                templateUrl: 'assets/templates/identity/changeEmail.html',
                controller: "changeEmailCtrl",
                resolve: {
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Update User Profile"};
                  }],
                }
            })
            .state('verifyPhone', {
                url: '/verifyPhone?userId',
                templateUrl: 'assets/templates/identity/verifyPhone.html',
                controller: "verifyPhoneCtrl",
                resolve: {
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Verify Phone"};
                  }],
                  impersonatorCheck: ['sessionService', '$q','$state', function(sessionService, $q, $state) {
                    var deferred = $q.defer();
                    if (sessionService.getCurrentUserProfile().impersonator === 'True') {
                      $state.go('dashboard');
                      deferred.reject();
                    } else {
                      deferred.resolve();
                    }
                    return deferred.promise;
                  }]
                }
            })
            .state('confirmPassword', {
                url: '/confirmPassword',
                templateUrl: 'assets/templates/identity/confirmPassword.html',
                resolve: {
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Confirm Password"};
                  }],
                }
            })
            .state('callbackAction', {
                url: '/callback/:response',
                templateUrl: 'assets/templates/common/loading.html',
                controller: 'identityCallbackCtrl'
            })
            .state('setPassword', {
                url: '/setPassword',
                templateUrl: 'assets/templates/identity/setPassword.html',
                controller: 'setPasswordCtrl',
                resolve: {
                  meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                    $rootScope.meta = {title: "Set Password"};
                  }],
                }
            })
    }]);

identityModule.controller('IdentityBaseCtrl', Patersons.IdentityBaseCtrl);
identityModule.controller('identityCallbackCtrl', Patersons.CallbackCtrl);
identityModule.controller('verifyPhoneCtrl', Patersons.VerifyPhoneCtrl);
identityModule.controller('changePhoneCtrl', Patersons.ChangePhoneCtrl);
identityModule.controller('forgottenPanCtrl', Patersons.ForgottenPanCtrl);
identityModule.controller('forgottenPasswordCtrl', Patersons.ForgottenPasswordCtrl);
identityModule.controller('changePasswordCtrl', Patersons.ChangePasswordCtrl);
identityModule.controller('changeEmailCtrl', Patersons.ChangeEmailCtrl);
identityModule.controller('setPasswordCtrl', Patersons.SetPasswordCtrl);
